import { render, staticRenderFns } from "./SelectMatchType.vue?vue&type=template&id=f2b9b1fc&scoped=true&"
import script from "./SelectMatchType.vue?vue&type=script&lang=js&"
export * from "./SelectMatchType.vue?vue&type=script&lang=js&"
import style0 from "./SelectMatchType.vue?vue&type=style&index=0&id=f2b9b1fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2b9b1fc",
  null
  
)

export default component.exports